<template>
    <div class="live-column">
        <column-skeleton v-if="loading" style="margin-bottom: 100vh"></column-skeleton>

        <img :src="live.cover_img" class="live-column-banner" />

        <div class="live-column-header">
            <div class="header-title">{{ live.title }}</div>
            <div class="header-author">
                已开展{{ live.current_count }}节 | 共{{ live.live_count }}节
            </div>
        </div>
        <van-tabs>
            <div v-for="item in dlyTabContent" :key="item.id">
                <van-tab :disabled="item.name==''" :title="item.name" v-if="item.content_type === 1">
                        <div class="live-column-content">
                            <div style="margin-top: 20px" v-if="forecast != null && forecast.length > 0">
                                <div class="live-list-section-title">直播中/预告</div>
                                <div class="live-list-section">
                                    <van-row @click="go_detail(item)" v-for="item in forecast" :key="item.id">
                                        <div class="live-list-section-box">
                                            <div class="live-list-section-left">
                                                <van-image class="live-list-section-left-img" fit="contain" :src="item.cover_img" />
                                                <img v-if="item.live_status == 0" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_count_down.svg" alt=""/>
                                                <img v-if="item.live_status == 1" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_process.svg" alt=""/>
                                                <img v-if="item.live_status == 2" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_history.svg" alt=""/>
                                            </div>
                                            <div class="live-list-section-right">
                                                <div class="live-list-section-right-title">{{ item.title }}</div>
                                                <div class="live-list-section-right-detail">
                                                    {{ item.start_at }}
                                                    <span class="live-list-section-right-detail-join">
                                                        {{ item.live_status === 0 ? (item.isAppointment ? '已预约' : '预约') : '加入' }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </van-row>
                                </div>
                            </div>

                            <div class="live-backs" style="margin-top: 20px" v-if="backs && backs.length > 0">
                                <div class="live-list-section-title">精彩回放</div>
                                <div class="live-list-section" style="margin-top: 22px">
                                    <van-row @click="go_detail(item)" v-for="item in backs" :key="item.id">
                                        <div class="live-list-section-box">
                                            <div class="live-list-section-left">
                                                <van-image class="live-list-section-left-img" fit="contain" :src="item.cover_img" />
                                                <img class="live-list-section-left-zl" src="/static/two/icon_list_tag_live_history.svg" alt="" />
                                                <div class="live-list-section-left-time">
                                                    <span>{{ item.duration_format }}</span>
                                                </div>
                                            </div>
                                            <div class="live-list-section-right">
                                                <div class="live-list-section-right-title">{{ item.title }}</div>
                                                <div class="live-list-section-right-detail">{{ item.view_count }}人观看</div>
                                            </div>
                                        </div>
                                    </van-row>
                                </div>
                            </div>
                    </div>
                </van-tab>
                <van-tab :title="item.name" v-else-if="item.content_type === 2 && item.column_items && item.column_items.length > 0 && item.column_items[0].content">
                    <div v-for="recommendItem in item.column_items" :key="recommendItem.id">
                        <Lives v-if="recommendItem.content && recommendItem.content.origin_type === 4" :dataItem="recommendItem.content"></Lives>
                        <Medicine v-if="recommendItem.content && recommendItem.content.origin_type === 30" :dataItem="recommendItem.content" />
                        <Special v-if="recommendItem.content && recommendItem.content.origin_type === 13" :dataItem="recommendItem.content" />
                        <Academic v-if="recommendItem.content && recommendItem.content.origin_type === 31" :dataItem="recommendItem.content"></Academic>
                        <Article v-if="recommendItem.content && recommendItem.content.origin_type === 2" :dataItem="recommendItem.content"></Article>
                    </div>
                </van-tab>
                <van-tab :disabled="item.name==''" :title="item.name" v-if="item.content_type === 3 && item.content && item.content !== ''">
                    <div class="diy-content" v-html="item.content"></div>
                </van-tab>
            </div>
        </van-tabs>
        <div class="live-column-footer">
            <van-grid :column-num="2" direction="horizontal">
                <van-grid-item @click="favorite()" v-if="live.isFavorite" icon="/static/img/course/icon_course_favorite_on_20.svg" text="已收藏" />
                <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏" />
                <van-grid-item @click="openShareData" icon="/static/img/course/icon_course_share_24.svg" text="分享" />
            </van-grid>
        </div>

        <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
            <img class="share-top-img" src="/static/img/pic_course_share_text.svg" alt="" />
            <div class="share-img">
                <img :src="htmlUrl" style="width: 100%" v-if="htmlUrl != ''" alt="" />
            </div>
            <div class="share-cancel-btn" @click="showShareDialog = false">
                <img src="/static/img/course/icon_course_share_close.svg" alt="" />
            </div>
        </van-dialog>
        <Back bottom="14vh"></Back>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import columnSkeleton from '@/skeleton/columnSkeleton'
import { Lives, Article, Special, Medicine, Academic } from '@/components/newItemconent/index.js'
import Back from '@/components/back'
import LiveSingle from '../list/live-single'
export default {
    name: 'live-column',
    components: {
        Back,
        LiveSingle,
        'column-skeleton': columnSkeleton,
        Lives,
        Article,
        Medicine,
        Special,
        Academic
    },
    data() {
        return {
            value: '',
            active: '',
            list: [],
            loading: true,
            finished: false,
            live: {},
            forecast: [],
            backs: [],
            share_data: {},
            showShareDialog: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            tabsActive: '专栏介绍',
            dlyTabContent: []
        }
    },
    methods: {
        onLoad() {
            // 数据全部加载完成
            if (this.list.length >= 40) {
                this.finished = true
            }
        },
        fetch(scene) {
            if (scene === 'live') {
                Interface.getData('get', Interface.live.column.detail + this.id).then(res => {
                    this.live = res.data.live
                    this.forecast = res.data.forecast

                    if (this.live.columns == null || this.live.columns.length == 0) {
                        this.dlyTabContent.push(
                            {
                                name: '目录',
                                content_type: 1
                            },
                            {
                                name: '',
                                content_type: 1
                            }
                        )
                    } else {
                        this.dlyTabContent = res.data.live.columns
                    }
                    if (this.dlyTabContent.length <= 2){
                        this.dlyTabContent.push({
                            name: '',
                            content_type: 1
                        })
                    }

                    this.backs = res.data.backs
                    this.loading = false
                    document.title = this.live.title
                    if (this.live) {
                        Interface.getShareInfo(this, this.live.title, this.live.cover_img, '')
                    }
                })
            } else if (scene === 'share') {
                let params = {
                    content_id: this.id,
                    type: 4
                }
                Interface.getData('get', Interface.share, params).then(res => {
                    this.htmlUrl = res.data.post_img_url
                })
            }
        },
        favorite() {
            Interface.getData('get', Interface.live.favorite + this.id).then(res => {
                if (res.code == 0) {
                    this.live.isFavorite = !this.live.isFavorite
                }
            })
        },
        onClickIcon() {},
        onClickButton() {},
        go_detail(item) {
            if (item.live_status === 0) {
                this.$router.push({ name: 'live-detail', params: { id: item.id } })
            } else {
                this.$router.push({ name: 'live-detail-home', params: { id: item.id } })
            }
        },
        openShareData() {
            this.showShareDialog = true
        }
    },
    watch:{
        async $route(to,from){
            this.id = this.$route.params.id
            this.fetch('live')
            this.fetch('share')
        }
    },
    created() {
        this.id = this.$route.params.id
        this.fetch('live')
        this.fetch('share')
    }
}
</script>

<style lang="scss">
@import './index.scss';

.diy-content {
    padding: 15px 15px 15px;
    padding-bottom: 0px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #79797d;
    letter-spacing: 0;
    line-height: 1.8;
    text-align: justify;

    * {
        max-width: 100% !important;
        box-sizing: border-box !important;
        word-break: break-all;

        ul,
        ol {
            padding-left: 5px !important;
        }

        .list-paddingleft-2 {
            padding-left: 5px !important;
        }

        table {
            max-width: 100% !important;
            td {
                max-width: 150px !important;
            }
        }

        ul,
        ul li {
            list-style-type: disc;
            line-height: inherit;
            padding: inherit;
        }
        ol {
            list-style-type: inherit;
            line-height: inherit;
            padding: inherit;
        }
        ol li {
            list-style-type: decimal;
            line-height: inherit;
        }

        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
        //overflow-x: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/live/column/index.vue